import type { EventName } from "@lit/react";
import { LoginOverlay as LoginOverlayElement, type LoginOverlayEventMap as _LoginOverlayEventMap, } from "@vaadin/login/vaadin-login-overlay.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { LoginOverlayElement, };
export type LoginOverlayEventMap = Readonly<{
    onClosed: EventName<_LoginOverlayEventMap["closed"]>;
    onDescriptionChanged: EventName<_LoginOverlayEventMap["description-changed"]>;
    onDisabledChanged: EventName<_LoginOverlayEventMap["disabled-changed"]>;
    onErrorChanged: EventName<_LoginOverlayEventMap["error-changed"]>;
    onForgotPassword: EventName<_LoginOverlayEventMap["forgot-password"]>;
    onLogin: EventName<_LoginOverlayEventMap["login"]>;
}>;
const events = { onClosed: "closed", onDescriptionChanged: "description-changed", onDisabledChanged: "disabled-changed", onErrorChanged: "error-changed", onForgotPassword: "forgot-password", onLogin: "login" } as LoginOverlayEventMap;
export type LoginOverlayProps = WebComponentProps<LoginOverlayElement, LoginOverlayEventMap>;
export const LoginOverlay = createComponent({
    elementClass: LoginOverlayElement, events, react: React, tagName: "vaadin-login-overlay"
});
